import { z } from 'zod'

// Spring Data 의 Slice 응답 봉투. 목록 엔드포인트가 페이지를 넘길 때 content 와 함께 실어 보낸다.
// 앱이 읽는 것은 content 와 last(다음 페이지 유무)뿐이라 pageable·sort 는 받지 않는다.
export const sliceSchema = <Item extends z.ZodType>(item: Item) =>
  z.object({
    content: z.array(item),
    first: z.boolean(),
    last: z.boolean(),
    size: z.number(),
    number: z.number(),
    numberOfElements: z.number(),
    empty: z.boolean(),
  })

export type Slice<Item> = {
  content: Item[]
  first: boolean
  last: boolean
  size: number
  number: number
  numberOfElements: number
  empty: boolean
}

// adapter 가 검증을 마친 뒤 줄마다 모양을 바꿀 때 쓴다. lenient 모드가 검증에 실패한 raw 나 본문 없는 응답을
// 그대로 넘겨도 모양 바꾸기는 거치게 하고, 본문이 없으면 빈 목록으로 읽는다.
export const mapSliceContent = <Item, Next>(
  slice: Slice<Item> | undefined,
  map: (item: Item) => Next,
): Slice<Next> =>
  slice
    ? { ...slice, content: (slice.content ?? []).map(map) }
    : { content: [], first: true, last: true, size: 0, number: 0, numberOfElements: 0, empty: true }
